module.exports = __webpack_public_path__ + "img/028-creativity.b8f22334.png";